export default __webpack_public_path__ + "static/media/fish_oil2.959bf013.png";